import { toast } from "react-toastify";
import axiosConfig from "../axiosConfig.js";

class EmailService {
    addEmailByPhone = async (requestData, token) => {
        let errorMessage;
        try {
            const response = await axiosConfig.post("Auth/AddEmailByPhone", requestData);
            return response;
        } catch (error) {
            errorMessage = error?.message || "Email not add"; // Fallback message
        }finally{
            toast.error(errorMessage);
        }
    };
}

const instance = new EmailService();

export default instance;
